'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HIRA_DIGRAPHS = exports.HIRA_DIGRAPHS = ['ぁ', 'ぃ', 'ぅ', 'ぇ', 'ぉ', 'ゃ', 'ゅ', 'ょ', 'ゎ', 'ゕ', 'ゖ'];
var KATA_DIGRAPHS = exports.KATA_DIGRAPHS = ['ァ', 'ィ', 'ゥ', 'ェ', 'ォ', 'ャ', 'ュ', 'ョ', 'ヮ', 'ヵ', 'ヶ'];
var PATTERN_NAMES = exports.PATTERN_NAMES = {
  HEIBAN: {
    EN: 'heiban',
    JA: '平板'
  },
  ATAMADAKA: {
    EN: 'atamadaka',
    JA: '頭高'
  },
  NAKADAKA: {
    EN: 'nakadaka',
    JA: '中高'
  },
  ODAKA: {
    EN: 'odaka',
    JA: '尾高'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/hatsuon/dist/constants.js
// module id = 540
// module chunks = 0